import {
  DataContainer,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";
import Style from "./aiOrderList.module.scss";
import Filter from "./Filter";
import SendExcelData from "./SendExcelData";
import Select from "react-select";
import { SimpleReport } from "../../Global/SimpleReport";
import useAiOrderList from "./useAiOrderList";
import ChatList from "./ChatList";

const AiOrderList = () => {
  const {
    date,
    isLoading,
    isFetching,
    aiOrdersList,
    aiordersState,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    isDateRangeApplied,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleExcelDownload,
    handleFilterAction,
    handleChatAction,
    updateOrdersFields,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    sendExcelData,
    handleSearch,
    handleSort,
    modalClose,
    refetch,
    getRow,
  } = useAiOrderList();

  return (
    <>
      <HeadingGroup title="AI Orders" className={`pro-mb-4`}>
        <div className="col dropdown-filter pro-d-flex">
          <button
            className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
            type="submit"
            onClick={handleExcelDownload}
          >
            <span className="material-symbols-outlined x4">download</span>
            <span>{`Export Data`}</span>
          </button>
        </div>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="row gx-2">
          <div className={`${isFetching ? "col" : "col-auto"}`}>
            <SearchFilters
              onSearchInput={handleSearch}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              showClearFilters={
                aiordersState?.search !== "" || isDateRangeApplied ? true : false
              }
              handleClear={handleClearClick}
              searchInputProps={{ value: aiordersState?.search }}
              handleActionClick={handleEditColumnsClick}
              dropDownFilter={
                <>
                  <div className="col-auto">
                    <CustomDateRangePicker
                      defaultDateRange={date}
                      handleDateRangeChange={handleDateRangeChange}
                    />
                  </div>
                </>
              }
              onDateChange={handleDateChange}
              initialDateRange={date}
            />
          </div>
          {!isFetching && (
            <div className="col-auto">
              <button
                className={`pro-btn pro-btn-outline pro-h-100 pro-px-5 ${Style.filter_btn}`}
                onClick={handleFilterAction}
              >
                <span className="material-symbols-outlined">tune</span>
                <span>Filter</span>
              </button>
            </div>
          )}
        </div>
        {aiOrdersList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={aiOrdersList?.data?.result || []}
            uniqueID={"id"}
            fields={aiOrdersList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={aiordersState?.clearSelection}
            perpage={aiordersState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}
      
        {aiOrdersList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={aiordersState?.currentPage}
            totalPageCount={Math.ceil(
              aiordersState.totalOrderCount / aiordersState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === aiordersState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={aiOrdersList?.data?.fields || []}
              moduleId={aiOrdersList?.data?.module_id}
              updateData={updateOrdersFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={aiordersState.filterShow}
          handleClose={handleFilterAction}
          title={`Apply Filter`}
          backdrop="static"
        >
          <Filter />
        </OffCanvasLayout>
        <ModalLayout
          show={aiordersState.excelSendModal}
          handleClose={handleExcelDownload}
          title={`Send Excel Download Link`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              handleCloseModal={modalClose}
              sendExcelData={sendExcelData}
              isExcelLinkSend={isExcelLinkSend}
            />
          </div>
        </ModalLayout>
         <OffCanvasLayout
         show={aiordersState.chatShow}
          handleClose={handleChatAction}
          title={`Chat Bot`}
          backdrop="static"
        >
         <ChatList />
        </OffCanvasLayout>
      </div>
    </>
  );
};

export default AiOrderList;
